$(document).ready(function(){
  $(".cstmbeforearow").click(function(){
    window.scrollTo(0, 0);
  });
    var current_fs, next_fs, previous_fs; //fieldsets
    var opacity;
    var current = 1;
    var steps = $("fieldset").length;

    setProgressBar(current);

    $(".next").click(function(){

      current_fs = $(this).parents('fieldset');
      next_fs = $(this).parents('fieldset').next();

      //Add Class Active
      $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

      //show the next fieldset
      next_fs.show();
      //hide the current fieldset with style
      current_fs.animate({opacity: 0}, {
        step: function(now) {
          opacity = 1 - now;

          current_fs.css({
            'display': 'none',
            'position': 'relative'
          });
          next_fs.css({'opacity': opacity,'display': 'flex'});
        },
        duration: 500
      });
      setProgressBar(++current);
     var result_arr =[];
      if($(this).hasClass('last__nexr_result')){
       $('.FAQS_container.active').each(function() {
         var value_active = $(this).attr('data-result');
         result_arr.push(value_active);
       }).promise().done(function(){
         var n = result_arr.length; 
    var final_result =   mostFrequent(result_arr, n);
        var class_show = '.result_for_'+final_result;
         $(class_show).show();
         $('body').css('background','#000')
      });
       
      }
    });
   
   function mostFrequent(arr, n) {  
    var hash = new Map(); 
    for (var i = 0; i < n; i++) { 
        if(hash.has(arr[i])) 
            hash.set(arr[i], hash.get(arr[i])+1) 
        else
            hash.set(arr[i], 1) 
    } 
     var max_count = 0, res = -1; 
    hash.forEach((value,key) => {  
        if (max_count < value) { 
            res = key; 
            max_count = value; 
        } 
    }); 
  
    return res; 
} 

    $(".previous").click(function(){

      current_fs = $(this).parents('fieldset');
      previous_fs = $(this).parents('fieldset').prev();

      //Remove class active
      $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

      //show the previous fieldset
      previous_fs.show();

      //hide the current fieldset with style
      current_fs.animate({opacity: 0}, {
        step: function(now) {
          // for making fielset appear animation
          opacity = 1 - now;

          current_fs.css({
            'display': 'none',
            'position': 'relative'
          });
          previous_fs.css({'opacity': opacity, 'display': 'flex'});
        },
        duration: 500
      });
      setProgressBar(--current);
    });

    function setProgressBar(curStep){
      var percent = parseFloat(100 / steps) * curStep;
      percent = percent.toFixed();
      $(".progress-bar")
      .css("width",percent+"%")
    }

    $(".submit").click(function(){
      return false;
    })
    $(".FAQS_container").click(function(){
      
      var _index = $(this).find('.content_with-radio').attr('data-index');
      var _tipsHeading = $(this).find('.content_with-radio').attr('data-heading');
      var _tipsContent = $(this).find('.content_with-radio').attr('data-content');
      var _tipsImage = $(this).find('.img-sec').attr('data-src');
      localStorage.setItem('tipHeading_'+_index,  _tipsHeading);
      localStorage.setItem('tipContent_'+_index,  _tipsContent);
      localStorage.setItem('tipImage_'+_index,  _tipsImage);
     if($(this).hasClass('multiSelect')){
       $(this).toggleClass('active');
       if($(this).hasClass('active')){
         $(this).find('input').attr('checked','checked');
       }
       else{
       $(this).find('input').removeAttr('checked');
       }
     }
       else{
      $(this).addClass('active').siblings().removeClass('active');
     }
      $(this).parents('.Question-answer').find('.mainQuesQuizBtn .next').removeClass('disabled');
    });

   $('body').on('click','.mainQuesQuizBtnSubMitBtn', function(e){
      e.preventDefault();
      $('.mainQuizeSec4-flex').addClass('show');
      var _dataUrl = $(this).parents('.last_step').find('.FAQS_container.active .image-with-content').attr('data-url');
      var _dataIndex = $(this).parents('.last_step').find('.FAQS_container.active .image-with-content').attr('data-index');
      sessionStorage.setItem('pageDataUrl', _dataUrl);
      sessionStorage.setItem('pageDataIndex', _dataIndex);
      // window.location.href = _dataUrl;
       window.location.href = "/pages/quiz-intro";
    });

$(".quizname").keyup(Quizname);
  function Quizname (){
    var quiznames = $(".quizname").val();
    var alphabeticValue = quiznames.replace(/[^a-zA-Z\s]/g, '');
    var qcount = quiznames.replace(/[, ]/g, "").length;
    var qname_regex = /^[ A-Za-z ]*$/;
    if(qname_regex.test(quiznames) && qcount > 2){
      $('.quizname').css('border-bottom','1px solid green');
      $('#qnameerror').text(" ");
      return true;
    }
     else if(qcount < 3){
       $('.quizname').css('border-bottom','1px solid red');
       $('#qnameerror').text("Please enter your Name, use alphabetic characters only");
       return false;
     }
 }
  
$(".quizphone").keyup(Quizphone);
   
  function Quizphone (){
    var quizphone = $(".quizphone").val();
    var qphone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/
    if(qphone_regex.test(quizphone) && quizphone.length == 10){
      $('.quizphone').css('border-bottom','1px solid green');
      $('#quizphoneerror').text(" ");
      return true;
    }
     else if(!qphone_regex.test(quizphone) && quizphone.length != 10){
       $('.quizphone').css('border-bottom','1px solid red');
       $('#quizphoneerror').text("Please enter a valid 10 digits Number");
       return false;
     }
 }
  $('body').on('click','.startBtn', async function(e){
      e.preventDefault();
      var quiznameresult = Quizname();
      var quizphoneresult = Quizphone();
      var _dataUrl = $(this).parents('.last_step').find('.FAQS_container.active .image-with-content').attr('data-url');
      var newg = sessionStorage.getItem('pageDataUrl', _dataUrl);
       if(quiznameresult === true && quizphoneresult === true){
        var name = $('.quizIntroInput[type="text"]').val();
        var email = $('.quizIntroInput[type="Email"]').val();
        var storedQuizData = localStorage.getItem("QuizQuestion");
        var storedQuizDataArr = JSON.parse(storedQuizData);
     if( name && email )
     {
        gtag('event', 'Quiz_submit', {
          'send_to': 'G-C1KL70NW4X',
          'Name': name,
          'Phone': email,
          'Quiz':storedQuizDataArr
        });
       
      let QuizuserData =   {
    "event_type": "Quiz_Submit",
    "user_identity": "Quiz_Submit",
    "phone":email,
    "data": {
        "name":name,
        "mob":email,
        "QuizQuestion":storedQuizDataArr
    }
}
        const url = "https://flow-builder.limechat.ai/builder/v1/event/create";
        const headers = {
            "Content-Type": "application/json",
            "x-limechat-access-token": "yCNVe4uf0VLjxB23PpIwEKJvccNKylzhJdeg9UlUTxOBDHdDF83Rr7IhqA7wRkih",
            "Accept": "application/json"
        };

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(QuizuserData) // Convert data to JSON format
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const responseData = await response.json();
            // Handle responseData in your UI as needed
        } catch (error) {
            console.error("Error:", error);
            // Handle errors in your UI
        }
     }
    var name = localStorage.getItem("name");
    var email = localStorage.getItem("email");
    var text1 = localStorage.getItem("tipHeading_1");
    var content1 = localStorage.getItem("tipContent_1");
    var text2 = localStorage.getItem("tipHeading_2");
    var content2 = localStorage.getItem("tipContent_2");
    var text3 = localStorage.getItem("tipHeading_3");
    var content3 = localStorage.getItem("tipContent_3");
    var text4 = localStorage.getItem("tipHeading_4");
    var content4 = localStorage.getItem("tipContent_4");
	$.ajax({
		type: "POST",
		url: "https://myindiabazar.com/acnesquad_quiz/datastore/getquiz.php",
		data: {name:name, email:email, text1:text1, content1:content1, text2:text2, content2:content2, text3:text3, content3:content3, text4:text4, content4:content4},           
		cache: "false", 
		dataType: "text",
		success: function (result) {
		},
		fail: function (result){
		}
	});  
           setTimeout(() => {
         window.location.href = newg;
        }, 3000);
       }
    });
  });

                function myFunction() {
            var copyText = document.getElementById("myCode").textContent;

            
            var textArea = document.createElement("textarea");
            textArea.value = copyText;
            
            
            textArea.style.position = "fixed";
            textArea.style.opacity = 0;
            
            document.body.appendChild(textArea);
            textArea.select();
            
            try {
                var successful = document.execCommand('copy');
                if (successful) {
                    var copyMessage = document.getElementById("copyMessage");
                    copyMessage.classList.add("show");
                    setTimeout(function() {
                        copyMessage.classList.remove("show");
                    }, 2000); 
                  if($('body').hasClass('Logedd__in')){
                     window.location.href = "/";
                  }else{
                  window.location.href = "/account/login?redirectq=quiz";
                  }
                } else {
                    console.error('Copying text command was unsuccessful');
                }
            } catch (err) {
                console.error('Oops, unable to copy', err);
            }
            
            document.body.removeChild(textArea);
        }